import PropTypes from 'prop-types';

// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as Constants from './constants';

const AddressFieldsMeta = PropTypes.shape({
  type: PropTypes.string,
  field: PropTypes.oneOf([
    Constants.ADDRESS_FIELD_ADDRESS1,
    Constants.ADDRESS_FIELD_ADDRESS2,
    Constants.ADDRESS_FIELD_CITY,
    Constants.ADDRESS_FIELD_STATE,
    Constants.ADDRESS_FIELD_ZIP,
    Constants.ADDRESS_FIELD_GENDER,
  ]),
  label_translation_key: PropTypes.string,
  required: PropTypes.bool,
});

const AgeVerification = PropTypes.shape({
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  date_of_birth: PropTypes.string,
  first_name: PropTypes.string,
  gender: PropTypes.string,
  last_name: PropTypes.string,
  meta: PropTypes.shape({
    address: PropTypes.arrayOf(AddressFieldsMeta),
  }),
  state: PropTypes.string,
  user_info_needed_explanation: PropTypes.string,
  user_step: PropTypes.oneOf([
    Constants.STEP_DOB_NAME,
    Constants.STEP_ADDRESS,
    Constants.STEP_ADDRESS_RETRY,
    Constants.STEP_ID_PHOTOS,
    Constants.STEP_ID_PHOTOS_RETRY,
  ]),
  verification_status: PropTypes.oneOf([
    Constants.STATUS_PENDING_USER_INFO,
    Constants.STATUS_PENDING_REVIEW,
    Constants.STATUS_PENDING_APPROVAL,
    Constants.STATUS_FAILED,
    Constants.STATUS_VERIFIED,
  ]),
  verified_for_purchase: PropTypes.bool.isRequired,
  verified_for_warranty_replacement: PropTypes.bool.isRequired,
  zip: PropTypes.string,
});

const AVNationalIDTypes = PropTypes.oneOf([
  Constants.AV_NATIONAL_ID_TYPES.TAX_CODE,
  Constants.AV_NATIONAL_ID_TYPES.PASSPORT,
  Constants.AV_NATIONAL_ID_TYPES.LAST_4_SSN,
  Constants.AV_NATIONAL_ID_TYPES.DRIVERS_LICENSE,
]);

const isBusy = PropTypes.shape({
  busy: PropTypes.bool,
  component: PropTypes.string,
});

const propTypes = {
  ...PropTypes,
  AgeVerification,
  AddressFieldsMeta,
  AVNationalIDTypes,
  isBusy,
};

export default propTypes;
